<template>
  <pre ref="pre" :class="`${languageClass} pre`"><code :class="`${languageClass} code`" v-html="html" /></pre>
</template>
<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import Prism from 'prismjs'
import 'prismjs/themes/prism-okaidia.css'

@Options({
  props: {
    code: String,
    grammar: String,
    language: String,
    lineStart: Number
  }
})
export default class CodeBlock extends Vue {
  public html: string = ''
  public code!: string
  public grammar!: string
  private grammar_: string = ''
  public language!: string
  private language_: string = ''
  public pre!: HTMLPreElement
  public languageClass: string = ''
  private defaultLanguage: string = 'javascript'
  private defaultGrammar: string = 'javascript'
  private lineStart!: number

  created() {
    // this.highlight()
    this.languageClass = `language-${this.language}`
  }

  mounted() {
    this.pre = this.$refs.pre as HTMLPreElement
    // line numbers
    const lineNumbersDiv = document.createElement('div')
    lineNumbersDiv.className = 'line-numbers'
    this.pre.append(lineNumbersDiv)

    this.html.split('\n').forEach((line, index) => {
      const lineStart = this.lineStart ?? 0
      const lineNumber = lineStart + index + 1
      const span = document.createElement('span')
      span.className = 'line-number-span'
      const br = document.createElement('br')
      br.className = 'line-number-br'
      span.innerHTML = `${lineNumber}`
      lineNumbersDiv.append(span)
      lineNumbersDiv.append(br)
    })
  }

  highlight() {
    this.language_ = this.language == null ? 'javascript' : this.language
    if (this.language_.toLowerCase() === 'vue') {
      this.language_ = 'html'
    }
    this.grammar_ = this.grammar == null ? this.language_ : this.grammar
    const grammar = Prism.languages[this.grammar_]
    try {
      this.html = Prism.highlight(this.code.trim(), grammar, this.language_)
    } catch (e) {
      if (e != null && (e as Error).message != null) {
        console.log((e as Error).message)
        if ((e as Error).message.includes('has no grammar')) {
          this.html = Prism.highlight(this.code.trim(), Prism.languages[this.defaultGrammar], this.language_)
        }
      }
    }
  }
}
</script>
<style lang="scss">
.line-numbers {
  position: absolute;
  top: 1.5em;
  left: 0em;
  width: 4.5em;
  border-right: 1px solid #999;
  text-align: center;
}
.line-number-br {
  user-select: none;
}
.line-number-span {
  color: #999;
  user-select: none;
}
pre[class*='language-'].pre {
  margin: 1rem auto;
  width: 100%;
  box-sizing: border-box;
  // max-width: 90%;
  padding-left: 4.8em;
  padding-top: 1.5em;
  padding-bottom: 2em;
  position: relative;
}
code[class*='language-'].code {
  white-space: pre-wrap;
}
</style>
